module.exports = require("fuse.js");